export default __webpack_public_path__ + "static/media/longchamp3.05df2a82.jpg";